"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useId } from 'react';
import styles from './Section.module.scss.mjs';
import clsx from 'clsx';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { ContextMenuSection } from '../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';

const Section = flowComponent("Section", (props) => {
  const {
    children,
    className,
    ref,
    renderContextMenuSection,
    hideSeparator,
    ...rest
  } = props;
  if (!children) {
    return null;
  }
  if (renderContextMenuSection) {
    return /* @__PURE__ */ jsx(ContextMenuSection, { ref, children });
  }
  const rootClassName = clsx(
    styles.section,
    className,
    hideSeparator && styles.hideSeparator
  );
  const headingId = useId();
  const propsContext = {
    Heading: {
      level: 2,
      id: headingId,
      className: styles.heading
    },
    Header: {
      renderSectionHeader: true
    },
    List: {
      "aria-labelledby": headingId
    }
  };
  return /* @__PURE__ */ jsx("section", { ...rest, className: rootClassName, ref, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children }) });
});

export { Section, Section as default };
//# sourceMappingURL=Section.mjs.map
